/**
 * @class L.Control.MapFocus
 * Кнопка фокусировки на карте
 */
L.Control.MapFocus = L.Control.extend({
	options: {
		title: 'Сфокусироваться',
		position: 'topleft',
	},

    initialize: function(options) {
        L.setOptions(this, options);
    },

	onAdd: function (map) {
		var container = L.DomUtil.create('feature-collection', 'leaflet-control-mapprint leaflet-bar leaflet-control');
		this.link = L.DomUtil.create('a', 'fa fa-dot-circle-o leaflet-bar-part', container);
        this.link.style.cursor = 'pointer';
		this.link.title = this.options.title;
		L.DomEvent.addListener(this.link, 'click', this.focusMap.bind(this), this.options);

		return container;
	},

	focusMap: function (event) {
		window.bus.$emit('map:focus');
		event.stopPropagation();
		return false;
	}
});

/**
 * Конструктор кнопки фокусировки на карте
 * @param options
 * @returns {L.Control.MapFocus}
 */
L.mapFocus = function(options) {
	return new L.Control.MapFocus(options);
};



// WEBPACK FOOTER //
// ./src/components/leaflet/focus/leaflet.focus.js